// src/redux/slices/popupTriggerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartChangeTrigger: 0,
  cartItemCount: 0,
};

const popupTriggerSlice = createSlice({
  name: "popupTrigger",
  initialState,
  reducers: {
    triggerCartChange: (state) => {
      state.cartChangeTrigger += 1; // Notify via increment
    },
    setCartItemCount: (state, action) => {
      state.cartItemCount = action.payload;
    },
  },
});

export const { triggerCartChange ,setCartItemCount} = popupTriggerSlice.actions;
export default popupTriggerSlice.reducer;
